<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if (srDetailLoading) {
      <app-skeleton-loader
        [formLoader]="true"
        [noOfFields]="6"
      ></app-skeleton-loader>
      } @else {
      <form [formGroup]="form">
        @if (step >= 1 && form.controls) {
           <!-- Action for show notes -->       
          @if (srNumber && srInprgoressAwating && !srDetailLoading) {
            <app-validation-message
              type="info"
              [content]="{
                title: 'SECTION_NOTES' | translate,
                message: 'SECTION_NOTES_DESCRIPTION' | translate
              }"
              [showbutton]="false"
              [buttonText]="'VIEW_NOTES' | translate"
              (onBtnClick)="showNotes = true"
            />
          } 

        <section>
          <h1 class="section-heading">
            {{ "TRADE_LICENSE_DETAILS" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-option-field
                [label]="'LICENCE_AUTHORITY' | translate"
                [control]="form.get('licenseIssuingAuthority')!"
                [lovType]="lookupKey.DC_LIC_AUTH"
                (onSelectionChange)="onLovChnage($event)"
                [valueKey]="'Description'"
                [labelKey]="lang == 'en' ? 'Description' : 'High'"
                (onSelectionChange)="onLicenseAuthorityAndTypeChagne()"
              >
              </app-option-field>
            </div>
            <!-- [valueKey]="lang == 'en' ? 'Description' : 'High'" -->           
            <div class="field-control">
              <app-option-field
                [control]="form.get('licenceType')"
                [label]="'LICENCE_TYPE' | translate"
                [lovType]="lookupKey.DC_LIC_TYPE"
                [parentControl]="form.get('licenseIssuingAuthority')!"
                [parentLovType]="lookupKey.DC_LIC_AUTH"
                [parentKey]="'Name'"
                (onSelectionChange)="onLicenseAuthorityAndTypeChagne()"
              >
              </app-option-field>
            </div>

            @if(((form.get('licenseIssuingAuthority')?.value != fieldValue.WITHOUT_LICENSE &&
              form.get('licenseIssuingAuthority')?.value != fieldValue.WITHOUT_LICENSE_AR )) ||
              (form.get('licenceType')?.value == fieldValue.OFFSHORE_LICENSE ||
              form.get('licenceType')?.value == fieldValue.OFFSHORE_LICENSE_AR)){
              <div class="field-control">
                <app-text-field
                  [label]="
                    (form.get('licenceType')?.value ==
                      fieldValue.OFFSHORE_LICENSE ||
                    form.get('licenceType')?.value ==
                      fieldValue.OFFSHORE_LICENSE_AR
                      ? 'OFFSHORE_REGISTRATION_NUMBER'
                      : 'LICENCE_NUMBER'
                    ) | translate
                  "
                  [control]="form.get('licenceNumber')!"
                  [maxlength]="150"
                  (blur)="getLicenseDetail()"
                >
                </app-text-field>
              </div>
            }
            @if (!isTradeLicenseValid && licenseData && showActions) {
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message:
                  existingLicenseMessageKey
                  | translate : existingLicenseMessageParams
              }"
              type="error"
            />
            }
          </div>
        </section>
        } @if (step >= 2) {
        <section class="space-y-4">
          <h1 class="section-heading">
            {{ "COMPANY_DETAILS" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-text-field
                [label]="'TRADE_NAME_EN' | translate"
                [control]="form.get('tradeNameEn')!"
                [validationMessages]="{
                  english: 'VALIDATION_MSG.EN_LETTERS' | translate
                }"
                [maxlength]="150"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'TRADE_NAME_AR' | translate"
                [control]="form.get('tradeNameAr')!"
                [validationMessages]="{
                  arabic: 'VALIDATION_MSG.AR_LETTERS' | translate
                }"
                [maxlength]="150"
              ></app-text-field>
            </div>

            <!-- Membership Years Selection -->
            @if(selectedLicenseAuthority && selectedLicenseAuthority["Low"] ==
            "Freezone" && srSubType == service.MEMBERSHIP_RENEW) {
            <div class="field-control">
              <!-- <app-boolean
                [control]="form.get('membershipYear')"
                [label]="'MEMBERSHIP_TITLE' | translate"
                [options]="membershipYears"
                [disabled]="
                  !showActions ||
                  (form.get('membershipYear')?.disabled ? true : false)
                "
                (onSelectionChange)="calculateMemExpDate($event)"
              /> -->
              <app-option-field
                [control]="form.get('membershipYear')"
                [label]="'MEMBERSHIP_TITLE' | translate"
                [options]="membershipYears"
                [labelKey]="'label'"
                [valueKey]="'value'"
                (onSelectionChange)="calculateMemExpDate($event)"
              />
            </div>
            }

            
             <!-- if issueing authority without license and license type offshore -->
            @if((form.get('licenseIssuingAuthority')?.value == fieldValue.WITHOUT_LICENSE ||
            form.get('licenseIssuingAuthority')?.value == fieldValue.WITHOUT_LICENSE_AR )){
            <div class="field-control">
              <app-text-field
                [label]="'DECREE_NUMBER' | translate"
                [control]="form.get('decreeNumber')!"
              >
              </app-text-field>
            </div>
            <div class="field-control">
               <!-- <label class="field-label">{{'DECREE_ISSUE_DATE' | translate}}</label> -->
               <app-date
                  [control]="form.get('decreeIssueDate')"
                  [label]="'DECREE_ISSUE_DATE' | translate"
                  [allowedDate]="'past'"
                  (onDateChange)="onLicenseDateChange($event)"
                />
            </div>
            }@else {
            <div class="field-control">
              <!-- <label class="field-label">
                {{
                  (form.get("licenceType")?.value ==
                    fieldValue.OFFSHORE_LICENSE ||
                  form.get("licenceType")?.value ==
                    fieldValue.OFFSHORE_LICENSE_AR
                    ? "OFFSHORE_REGISTRATION_ISSUEDATE"
                    : "ISSUE_DATE"
                  ) | translate
                }}</label
              > -->
              <div class="field-control">
                <app-date
                  [control]="form.get('issueDate')"
                  [label]="(form.get('licenceType')?.value ==
                    fieldValue.OFFSHORE_LICENSE ||
                  form.get('licenceType')?.value ==
                    fieldValue.OFFSHORE_LICENSE_AR
                    ? 'OFFSHORE_REGISTRATION_ISSUEDATE'
                    : 'ISSUE_DATE'
                  ) | translate"
                  [allowedDate]="'past'"
                  (onDateChange)="onLicenseDateChange($event)"
                />
              </div>
            </div>
            <div class="field-control">
              <!-- <label class="field-label">
                {{
                  (form.get("licenceType")?.value ==
                    fieldValue.OFFSHORE_LICENSE ||
                  form.get("licenceType")?.value ==
                    fieldValue.OFFSHORE_LICENSE_AR
                    ? "OFFSHORE_REGISTRATION_EXPRIYDATE"
                    : "EXPIRY_DATE"
                  ) | translate
                }}</label
              > -->
              <!-- [minYear]="renewExpiryMinYear" -->
              <div class="field-control" id="expiry_dt">
                <app-date
                  [allowedDate]="form.get('expiryDate')?.disabled && selectedLicenseAuthority['Low'] == 
                  'Freezone' && srSubType != service.MEMBERSHIP_RENEW ? 'all' : 'future'"
                  [control]="form.get('expiryDate')"
                  [label]=" (form.get('licenceType')?.value ==
                    fieldValue.OFFSHORE_LICENSE ||
                  form.get('licenceType')?.value ==
                    fieldValue.OFFSHORE_LICENSE_AR
                    ? 'OFFSHORE_REGISTRATION_EXPRIYDATE'
                    : 'EXPIRY_DATE'
                  ) | translate"
                  (onDateChange)="onLicenseDateChange($event)"
                />
              </div>
            </div>
            }

            <div class="field-control">
              <!-- <label class="field-label">{{
                "MEMBERSHIP_EXPIRY_DATE" | translate
              }}</label> -->
              <div class="field-control">
                <app-date
                  [allowedDate]="'future'"
                  [control]="form.get('membershipExpiryDate')"
                  [label]="'MEMBERSHIP_EXPIRY_DATE' | translate"
                />
              </div>
            </div>
            <div class="field-control">
              <app-option-field
                [label]="'NATIONALITY' | translate"
                [control]="form.get('nationality')!"
                [country]="true"
                [options]="countryLovList"                
                (onSelectionChange)="onNationalityChange()"
              >
              </app-option-field>
              <!-- [lovType]="lookupKey.COUNTRY" -->
            </div>
            <div class="field-control">
              <app-option-field
                [label]="'LEGAL_STATUS' | translate"
                [control]="form.get('legalStatus')!"
                [lovType]="lookupKey.LEGAL_STATUS"
                [valueKey]="'Description'"
                [labelKey]="lang == 'en' ? 'Description' : 'High'"
              >
              </app-option-field>
            </div>
            <div class="field-control">
              <app-option-field
                [label]="'FIRM_TYPE' | translate"
                [control]="form.get('firmType')!"
                [lovType]="lookupKey.FIRM_TYPE"
                [labelKey]="'Description'"
                [valueKey]="'Description'"
              >
              </app-option-field>
            </div>

            <!-- license type offshore -->
            @if(form.get('licenceType')?.value == fieldValue.OFFSHORE_LICENSE ||
            form.get('licenceType')?.value == fieldValue.OFFSHORE_LICENSE_AR){

            <div class="field-control">
              <app-text-field
                [label]="'LEGAL_NAME' | translate"
                [control]="form.get('legalName')!"
              >
              </app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'EMAIL' | translate"
                [placeholder]="'LEGAL_EMAIL' | translate"
                [control]="form.get('legalEmail')!"
                [validationMessages]="{
                  email: 'VALIDATION_MSG.VALID_EMAIL' | translate
                }"
                [maxlength]="100"
              >
              </app-text-field>
            </div>
            <div class="field-control">
              <app-mobile-number
                [label]="'LEGAL_CONTACT_NUMBER' | translate"
                [countryCodeControl]="form.get('legalContactCountryCode')!"
                [control]="form.get('legalContactNumber')!"
                [validationMessages]="{
                  mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                  uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                }"
              >
              </app-mobile-number>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'LEGAL_MEMBER_NUMBER' | translate"
                [control]="form.get('legalMemberNumber')!"
              >
              </app-text-field>
            </div>
            }
           
            <h3 class="text-lg text-gray-800 font-semibold mb-1">
              {{ "CONTACT_INFORMATION" | translate }}
            </h3>
            <div class="field-control">
              <app-text-field
                [label]="'OFFICE_NUMBER' | translate"
                [control]="form.get('officeAddress')!"
                [maxlength]="30"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'BUILDING_NAME' | translate"
                [control]="form.get('buildingName')!"
                [maxlength]="30"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'STREET' | translate"
                [control]="form.get('street')!"
                [maxlength]="100"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'ADDRESS' | translate"
                [control]="form.get('address')!"
                [maxlength]="200"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-mobile-number
                [label]="'MOBILE_NUMBER' | translate"
                [control]="form.get('phoneNumber')!"
                [countryCodeControl]="form.get('countryCode')!"
                [validationMessages]="{
                  mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                  uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                }"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'EMAIL' | translate"
                [control]="form.get('contactEmail')!"
                [validationMessages]="{
                  email: 'VALIDATION_MSG.VALID_EMAIL' | translate
                }"
                [maxlength]="100"
              ></app-text-field>
            </div>
          </div>
        </section>
        }

        <!-- Ownership -->
        @if (step >= 3 && !isOffshoreLicenseType) {
        <section class="space-y-4" id="owner-list">
          <h1 class="section-heading">
            {{ "OWNERSHIP_DETAILS" | translate }}
          </h1>
          <p class="text-sm text-gray-100 mb-4 font-light px-3">
            {{ "OWNERSHIP_NOTE" | translate }}
          </p>
          <div class="fields-container">
            @if(activeOwners?.length === 0 && isFromSumit){
            <div class="fields-error-container">
              {{ "VALIDATION_MSG.OWNER_NOT_ADDED" | translate }}
            </div>
            }
            <!-- added owner/manager card detail  -->
            @if (ownerList?.length) {
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-5">
              @for (owner of ownerList; track $index) {
              <div>
                <app-membership-owner
                  [owner]="owner"
                  (onActionClick)="ownerViewRemove($event)"
                  [showAction]="showActions"
                />
              </div>
              }
            </div>
            @if (showShareMsg) {
              <div class="mb-4">
                <app-validation-message
                  [content]="{
                    title: 'ALERT.SHARE_MSG' | translate,
                    message: 'ALERT.SHARE_FINAL_MSG_DESC' | translate
                  }"
                  type="error"
                />
            </div>
            } } @if (showActions) {
            <app-button
              [type]="'button'"
              [label]="'BUTTONS.ADD_OWNER' | translate"
              classesName="btn-edge-cut mb-8"
              (onBtnClick)="openAddOwnerModal()"
            />
            }
            <div class="field-control">
              <app-checkbox
                [control]="form.get('hasParentCompany')"
                [options]="[
                  { label: 'PARENT_COMPANY' | translate, value: 'Yes' }
                ]"
                [disabled]="!showActions"
              />
            </div>
            @if (form.get('hasParentCompany')?.value == 'Yes') {
            <div class="field-control">
              <app-text-field
                [label]="'LICENSE_NUMBER' | translate"
                [control]="form.get('parentCompanyLicenceNumber')!"
                [maxlength]="100"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'MEMBER_NUMBER' | translate"
                [control]="form.get('parentCompanyMemberNumber')!"
                [maxlength]="100"
                (blur)="checkMemberLicenseDetail()"
              ></app-text-field>
            </div>
            @if (showActions) {
            <div class="buttons-group">
              <app-button
                [type]="'button'"
                [label]="'BUTTONS.CHECK_DETAIL' | translate"
                classesName="card-edge-cut-white btn-edge-cut"
                (onBtnClick)="checkMemberLicenseDetail()"
              />
              @if (loaderValidateMemLicense) {
              <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
              }
            </div>
            }
            <!-- if not detail found show message -->
            <div class="mb-2">
              @if ( memberLicenseError && licenseMember['Error Code'] == 1 ) {
              <app-validation-message
                [content]="{
                  title: 'ALERT.NO_RESULTS_TITLE' | translate,
                  message: licenseMember['Error Message']
                }"
                type="error"
              />
              }
            </div>
            @if (licenseMember && licenseMember['Error Code'] != 1) {
            <div class="mt-5 mb-5 space-y-4">
              <table class="dc-table w-full text-sm text-dc-navy!">
                <tbody>
                  <tr class="border-b border-dc-navy!">
                    <td class="py-2 font-medium min-w-2xs">
                      {{ "MEMBER_NAME" | translate }}
                    </td>
                    <td class="py-2">
                      {{ licenseMember.MemberName }}<br />
                      {{ licenseMember?.MemberNameAra }}
                    </td>
                  </tr>
                  <tr class="border-dc-navy!">
                    <td class="py-2 font-medium min-w-2xs">
                      {{ "EXPIRY_DATE" | translate }}
                    </td>
                    <td class="py-2">
                      {{ licenseMember.ExpiryDate | date : "dd-MMMM-yyyy" }}
                    </td>
                  </tr>
                  <!-- <tr class="border-b">
                    <td class="py-2 font-medium">
                      {{ "LICENSE_STATUS" | translate }}
                    </td>
                    <td class="py-2">{{ licenseMember.Status }}</td>
                  </tr> -->
                </tbody>
              </table>
            </div>
            } }
          </div>
        </section>
        }

        <!-- Activities -->
        @if (step >= 4) {
          @if (!isOffshoreLicenseType) {
          <section class="space-y-4">
            <h1 class="section-heading">
              {{ "ACTIVITIES" | translate }}
            </h1>
            <div class="fields-container">
              <div class="field-control">
                <app-searchable-list
                  [label]="'SEARCH_ACTIVITY' | translate"
                  [placeholder]="'SEARCH_ACTIVITY' | translate"
                  [control]="form.get('activitySearch')!"
                  [selectedItems]="selectedActivities"
                  (onAdd)="addAactivity($event)"
                  (onRemove)="removeActivity($event)"
                  [lovType]="lookupKey.ACTIVITIES"
                  [allowAddNew]="true"
                  [notFoundText]="'ACTIVITY_NOT_FOUND' | translate"
                  (addNewItem)="openAddActivityForm($event)"
                  [showAction]="showActions"
                  (onSelectionClear)="clearActivity($event)"
                ></app-searchable-list>
              </div>
              <div class="field-control mt-8">
                <app-checkbox
                  [control]="form.get('activitiesConfirmed')"
                  [options]="[
                    { label: 'CONFIRM_ACTIVITIES' | translate, value: 'Yes' }
                  ]"
                  [disabled]="!showActions"
                />
              </div>
            </div>
          </section>
          }
        }

        <!-- Upload Documents Section -->
        @if (step >= 5) {
        <section class="space-y-4">
          <h1 class="section-heading">
            {{ "DOCUMENTS.TITLE" | translate }}
          </h1>
          @if(loadingDoc){
          <app-skeleton-loader
            [formLoader]="true"
            [noOfFields]="3"
          ></app-skeleton-loader>
          }
          @if(srFolder && !loadingDoc){
            <div class="fields-container">
              @for (dt of mainFromSectionDocs; track $index) {
              <div class="field-control">
                <app-file
                  #fileCmp
                  [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                  [documentType]="dt.nameEn"
                  (folderMissing)="openFolder()"
                  (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                  [showAction]="showActions"
                  [folder]="srFolder"
                  [documentServiceType]="documentServiceType.MEMBERSHIP"
                ></app-file>
              </div>
              }
            </div>
          }
        </section>
        } @if (step >= 6) { } 

        @if (step >= 4) {
        <!-- section for payment method -->
        <section>
          <h1 class="section-heading">
            {{ "SECTION_PAYMENT_METHOD" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
               <app-boolean
                [label]="'PAYMENT_METHOD' | translate"
                [control]="form.get('paymentMethod')!"
                [lovType]="lookupKey.PAYMENT_METHOD"
                [labelKey]="'Value'"                  
                [valueKey]="'Value'"
                (onSelectionChange)="onPaymentMethodChange($event)"
              />
            </div>
            @if ( noAdvancePaymentBalance) {
              <app-validation-message
                [content]="{
                  title: 'ALERT.ERROR' | translate,
                  message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
                }"
                type="error"
              />
            }
          </div>
        </section>
        }
        
        @if (ownerFieldError?.length > 0) {
        <div class="fields-error-container mb-4">
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: 'VALIDATION_MSG.FILL_OWNER_REQUIRED_FIELDS' | translate
            }"
            [showbutton]="false"
          ></app-validation-message>
          <ul class="list-disc ml-6 text-red-700 hidden">
            @for (f of ownerFieldError; track $index) {
            <li>{{ f }}</li>
            }
          </ul>
        </div>
        }

        <!-- Error Message -->
        @if(technicalErrorMsg){
        <app-validation-message
          [type]="'error'"
          [content]="{
            title: 'VALIDATION_MSG.ERROR' | translate,
            message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
          }"
          [showbutton]="false"
        ></app-validation-message>
        } 
        
        @if (errorMsg) {
        <app-validation-message
          [type]="'error'"
          [content]="{
            title: 'ALERT.ERROR' | translate,
            message: errorMsg
          }"
        >
        </app-validation-message>
        }

        <!-- Next and Close Button -->
        <div class="btn-section buttons-group">
          @if (showActions && !formSubmitLoader) {
            <app-button
              [type]="'button'"
              [label]="'BUTTONS.NEXT' | translate"
              classesName="btn-edge-cut btn-width-auto"
              (onBtnClick)="nextStep()"
            />
            @if (step > 1 && showSaveAndCloseAction) {
              <app-button
                [type]="'button'"
                [label]="'BUTTONS.SAVE_CLOSE' | translate"
                classesName="card-edge-cut-white !btn-edge-cut btn-width-auto"
                (onBtnClick)="saveAndClose()"
              />
            }
          } @if(formSubmitLoader){
          <app-button
            type="button"
            classesName="btn-edge-cut btn-width-auto"
            [label]="'PLEASE_WAIT' | translate"
            [disabled]="true"
          ></app-button>
          }
        </div>
      </form>
      }
    </div>
  </div>
  <!-- Form Completion Progress -->
  <div>
    @if (!srDetailLoading) {
    <app-service-progress
      [serviceName]="'GET_MEMBERSHIP' | translate"
      [completePercentage]="formProgress"
    />
    }
  </div>
</div>

<!-- Add Owner/Manager Modal -->
@if (addOwnerModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      class="modal-x-button"
      type="button"
      (click)="addOwnerModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "OWNER_FORM.TITLE" | translate }}
    </h1>
    <!-- content -->
    <app-add-owner-partner
      [(isOpen)]="addOwnerModal"
      (onBtnClick)="onOwnerSubmit($event)"
      [totalShare]="ownerTotalShare"
      [data]="selectedOwner"
      [allMembersData]="ownerList"
      [showAction]="showActions"
      [srFolder]="srFolder"
      [countryList]="countryLovList"
      (folderMissing)="openFolder()"
    ></app-add-owner-partner>
  </div>
</div>
}

<!-- Add activity Modal -->
@if (addActivityModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      class="modal-x-button"
      type="button"
      (click)="addActivityModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "ACTIVITY.ADD_NEW_ACTIVITY" | translate }}
    </h1>
    <!-- content -->
    <app-add-activity
      [(isOpen)]="addActivityModal"
      (onBtnClick)="saveNewActivity($event)"
      [data]="activityRecord"
    />
  </div>
</div>
} @if (showStep2DraftConfirmModal) {
<div class="dc-modal">
  <div class="dc-modal-container bg-white max-w-[450px]!">

    <h2 class="text-xl font-semibold text-dc-navy mb-3">
      {{ "TOAST_MESSAGES.INFORMATION" | translate }}
    </h2>
    <p class="mb-6 text-sm text-dc-navy!"[innerHTML]="'TOAST_MESSAGES.MEMBERSHIP_DRAFT_SAVE_CONFIRM' | translate">
      
    </p>
    <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-center">
      <app-button
        [type]="'button'"
        [label]="'BUTTONS.OK' | translate"
        classesName="btn-edge-cut"
        (onBtnClick)="confirmStep2DraftSave()"
      />
      <app-button
        [type]="'button'"
        [label]="'BUTTONS.CANCEL' | translate"
        classesName="card-edge-cut-white !btn-edge-cut"
        (onBtnClick)="cancelStep2DraftSave()"
      />
    </div>
  </div>
</div>
} @if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
} @if (pendingSrNumber) {
<app-pending-sr-modal
  [srNumber]="pendingSrNumber"
  (onClose)="closependingSrModal()"
/>
}

<!-- notes modal -->
@if(showNotes) {
<app-notes [srNumber]="srNumber" [allowSubmit]="true" (onClose)="showNotes = false;"></app-notes>
}
